import { createContext } from 'react'
import {
  CatalogDataset,
  CatalogSubscription,
  CatalogSubscriptionRequestStatus,
  CatalogSubscriptionStatus,
  CatalogSubscriptionType
} from '../../types'
import { UseMutationResult } from 'react-query'

export type CatalogSubscriptionContext = {
  state: {
    cartoDWAccountProject?: string
    publicView: boolean
    actives?: CatalogSubscription[]
    requested?: string[]
    samples?: string[]
    isSubscriptionsLoading: boolean
    isSamplesLoading: boolean
    requestSubscriptionMutation: UseMutationResult<unknown, Error, unknown>
    requestAccessSampleMutation: UseMutationResult<unknown, Error, unknown>
  }
  actions: {
    navigateToDataExplorer: (dataset: CatalogDataset, subscriptionType: CatalogSubscriptionType) => void
    sendSubscriptionRequest: (dataset: CatalogDataset, status?: CatalogSubscriptionRequestStatus) => Promise<unknown>
    checkIfSubscriptionRequested: (dataset: CatalogDataset) => boolean
    checkIfSubscribed: (dataset: CatalogDataset) => boolean
    getSubscriptionStatus: (dataset: CatalogDataset) => CatalogSubscriptionStatus | null
    getSubscriptionExpirationLeft: (dataset: CatalogDataset) => number
    getSubscriptionExpiration: (dataset: CatalogDataset) => Date | null
  }
}

export enum CatalogSubscriptionActions {}

export type CatalogSubscriptionAction = {
  type: CatalogSubscriptionActions
  payload: CatalogSubscriptionContext['state'][keyof CatalogSubscriptionContext['state']]
}

type ActionStub = CatalogSubscriptionContext['actions'][keyof CatalogSubscriptionContext['actions']]

const stub = ((
  _payload: CatalogSubscriptionAction['payload'][keyof CatalogSubscriptionAction['payload']],
  // eslint-disable-next-line
  secondaryPayload?: any
) => {
  throw new Error('You forgot to wrap your component in <FiltersProvider>.' + _payload + secondaryPayload)
}) as unknown as ActionStub

export const SUBSCRIPTIONS_INITIAL_DATA = {
  state: {},
  actions: {
    navigateToDataExplorer: stub,
    sendSubscriptionRequest: stub,
    checkIfSubscriptionRequested: stub,
    checkIfSubscribed: stub,
    getSubscriptionStatus: stub,
    getSubscriptionExpirationLeft: stub,
    getSubscriptionExpiration: stub
  }
}
export const CatalogSubscriptionDataContext = createContext(SUBSCRIPTIONS_INITIAL_DATA.state)
export const CatalogSubscriptionActionsContext = createContext(SUBSCRIPTIONS_INITIAL_DATA.actions)
